module.exports = __webpack_public_path__ + "static/interstate-a761f3890a58a5b06e643c90404b3c07.woff2";